var _circle, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "none",
    stroke: "#B4B2A9",
    strokeWidth: 1.5,
    strokeDasharray: "4 4",
    opacity: 0.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 28,
    x2: 44,
    y2: 60,
    stroke: "#B4B2A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 60,
    y2: 44,
    stroke: "#B4B2A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImageIcon);
export default __webpack_public_path__ + "static/media/add-image-icon.3cb5b59283697a7f5cfd6320e559771a.svg";
export { ForwardRef as ReactComponent };